import { FC, InputHTMLAttributes } from "react";
import styled from "styled-components";

type CheckboxProps = InputHTMLAttributes<HTMLInputElement> & {
  name: string;
  checked: boolean;
  label: string;
};

const Checkbox: FC<CheckboxProps> = ({
  name,
  checked,
  onChange,
  label,
  className,
  ...props
}) => {
  return (
    <LabelWrapper className={className}>
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        {...props}
      />{" "}
      <span>{label}</span>
    </LabelWrapper>
  );
};

export default Checkbox;

const LabelWrapper = styled.label`
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 10px;
  align-items: center;

  input[type="checkbox"] {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
    color: var(--nf-primary);
    width: 24px;
    height: 24px;
    border: 1px solid #e0e4e8;
    border-radius: 4px;
    display: grid;
    place-content: center;

    :hover {
      border: 1px solid var(--nf-primary);
      background: rgba(255, 90, 54, 0.1);
    }
  }

  input[type="checkbox"]:disabled {
    color: var(--nf-secondary);
    border: 1px solid #e0e4e8;

    :hover {
      border: 1px solid none;
      background: none;
    }
  }

  input[type="checkbox"]:disabled + span {
    color: #e0e4e8;
  }

  input[type="checkbox"]::before {
    content: "";
    width: 24px;
    height: 24px;
    border-radius: 4px;
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M6.41 0h11.18c2.23 0 3.037.232 3.852.668a4.543 4.543 0 0 1 1.89 1.89c.436.815.668 1.623.668 3.852v11.18c0 2.23-.232 3.037-.668 3.852a4.543 4.543 0 0 1-1.89 1.89c-.815.436-1.623.668-3.852.668H6.41c-2.23 0-3.037-.232-3.852-.668a4.543 4.543 0 0 1-1.89-1.89C.232 20.627 0 19.82 0 17.59V6.41c0-2.23.232-3.037.668-3.852a4.543 4.543 0 0 1 1.89-1.89C3.373.232 4.18 0 6.41 0z' fill='%23FF5A36'/%3E%3Cpath d='M7.41 1h9.18c2.23 0 3.037.232 3.852.668a4.543 4.543 0 0 1 1.89 1.89c.436.815.668 1.623.668 3.852v9.18c0 2.23-.232 3.037-.668 3.852a4.543 4.543 0 0 1-1.89 1.89c-.815.436-1.623.668-3.852.668H7.41c-2.23 0-3.037-.232-3.852-.668a4.543 4.543 0 0 1-1.89-1.89C1.232 19.627 1 18.82 1 16.59V7.41c0-2.23.232-3.037.668-3.852a4.543 4.543 0 0 1 1.89-1.89C4.373 1.232 5.18 1 7.41 1z' fill='%23FF5A36'/%3E%3Cpath d='m9.622 13.532 7.913-7.094a1 1 0 0 1 1.403.066l.06.066a1 1 0 0 1-.03 1.388l-8.624 8.557a1 1 0 0 1-1.426-.018L5.61 13.044a.992.992 0 0 1-.012-1.36l.022-.024a1 1 0 0 1 1.333-.122l2.669 1.994z' fill='%23FFF'/%3E%3C/g%3E%3C/svg%3E");
    transform: scale(0);
  }

  input[type="checkbox"]:disabled::before {
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M6.41 0h11.18c2.23 0 3.037.232 3.852.668a4.543 4.543 0 0 1 1.89 1.89c.436.815.668 1.623.668 3.852v11.18c0 2.23-.232 3.037-.668 3.852a4.543 4.543 0 0 1-1.89 1.89c-.815.436-1.623.668-3.852.668H6.41c-2.23 0-3.037-.232-3.852-.668a4.543 4.543 0 0 1-1.89-1.89C.232 20.627 0 19.82 0 17.59V6.41c0-2.23.232-3.037.668-3.852a4.543 4.543 0 0 1 1.89-1.89C3.373.232 4.18 0 6.41 0z' fill='%23e0e4e8'/%3E%3Cpath d='M7.41 1h9.18c2.23 0 3.037.232 3.852.668a4.543 4.543 0 0 1 1.89 1.89c.436.815.668 1.623.668 3.852v9.18c0 2.23-.232 3.037-.668 3.852a4.543 4.543 0 0 1-1.89 1.89c-.815.436-1.623.668-3.852.668H7.41c-2.23 0-3.037-.232-3.852-.668a4.543 4.543 0 0 1-1.89-1.89C1.232 19.627 1 18.82 1 16.59V7.41c0-2.23.232-3.037.668-3.852a4.543 4.543 0 0 1 1.89-1.89C4.373 1.232 5.18 1 7.41 1z' fill='%23e0e4e8'/%3E%3Cpath d='m9.622 13.532 7.913-7.094a1 1 0 0 1 1.403.066l.06.066a1 1 0 0 1-.03 1.388l-8.624 8.557a1 1 0 0 1-1.426-.018L5.61 13.044a.992.992 0 0 1-.012-1.36l.022-.024a1 1 0 0 1 1.333-.122l2.669 1.994z' fill='%23FFF'/%3E%3C/g%3E%3C/svg%3E");
  }

  input[type="checkbox"]:checked::before {
    transform: scale(1);
  }
`;
